import PropTypes from 'prop-types';
import { InfoBox, TabCreateInspection } from 'components';
import { InspectionStatus } from 'constants/inspections';
import { FormProvider } from 'providers';
import { useInspectionSelector } from 'stores';
import { contextAccordionTabsL3 } from './config/l3SubTabs';

// Contenuto della tab L3 "Idraulica". A differenza di L0/L1, che
// condividono un unico form globale montato da CreateInspection.jsx, L3 ha
// un form React Hook Form indipendente — ma l'hook (useInspectionL3) è
// istanziato in CreateInspection.jsx, non qui, così l'header condiviso
// (CreateInspectionButtons.jsx) può mostrare Salva/Annulla per L3 esattamente
// come per L0/L1. Vedi apps/web-bo/plans/features/l3-idraulica-tab.md.
//
// Due sotto-tab (Contesto dati generali / Riepilogo), mirror di L0/L1 —
// vedi ./config/l3SubTabs.js.
//
// Punto 8 (specifica designer 2026-09-01) — banner giallo quando l'attività
// L3 è "In corso" ma né l'utente né il proprietario del ponte/dell'attività
// hanno il modulo Livello 3 Idraulica attivo (l3ModuleCanEdit, store
// zustand — già il valore OR-combinato di l3Access.canEdit, vedi
// task-18-l3-condivisione-handoff-fe.md). Solo "In corso": per un'attività
// Archiviata/Consegnata l'accesso in modifica è comunque negato per altri
// motivi (inspectionDisabled), e in quello stato non si può nemmeno
// condividere (CanShareMap, useInspection.js) — il banner qui aggiungerebbe
// rumore senza informazione nuova. Testo verbatim dal designer: la
// condivisione è citata perché senza il modulo non è più possibile nemmeno
// quella (fix in useInspection.js/handleMyPermissions, stessa sessione).
// Un solo banner qui (non nei singoli accordion): visibile a prescindere da
// quale dei 6 accordion/2 sotto-tab sia aperto.
const L3_MODULE_MISSING_BANNER =
  "Per accedere in modifica a questa attività o condividerla è necessario che il tuo utente, il proprietario del ponte o il proprietario dell'attività abbiano attivo il modulo Livello 3 Idraulica. Contattaci per abilitare il modulo e ripristinare l'accesso.";

const L3Idraulica = ({ methods, handleSubmit, onSubmit, inspectionStatus }) => {
  const { l3ModuleCanEdit } = useInspectionSelector();
  const showL3ModuleMissingBanner =
    inspectionStatus === InspectionStatus.OnGoing && l3ModuleCanEdit === false;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      {showL3ModuleMissingBanner && (
        <InfoBox color="warning.light" text={L3_MODULE_MISSING_BANNER} />
      )}
      <TabCreateInspection tabs={contextAccordionTabsL3} />
    </FormProvider>
  );
};

L3Idraulica.propTypes = {
  methods: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inspectionStatus: PropTypes.number,
};

export { L3Idraulica };
